import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconWarning } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleNkfJank } from '../../actions';
import { isNkfJankRunning } from '../../functions';
/**
 * Debug toolbar item that freezes the main thread on purpose, to reproduce the
 * transmitted-audio dropouts on demand.
 *
 * The emit worklet buffers only ~96 ms, and the cleaned audio crosses the main
 * thread twice on its way out, so a main-thread stall longer than that punches a
 * hole in what the far side hears. Turning this on while speaking is how we
 * check whether the dropouts users report have that same shape.
 *
 * Shown only when config.nkfAec.jankButton is true — never in a normal build.
 */
class NkfJankButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityNkfJank';
    icon = IconWarning;
    label = 'toolbar.nkfJank';
    toggledLabel = 'toolbar.nkfJankOff';
    tooltip = 'toolbar.nkfJank';
    /**
     * Starts/stops the deliberate jank.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _running, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('nkf.jank', { enable: !_running }));
        dispatch(toggleNkfJank());
    }
    /**
     * Toggled (ON) while the jank is running.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._running;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _running: isNkfJankRunning(state)
    };
}
export default translate(connect(mapStateToProps)(NkfJankButton));
